import { Component, Inject, OnInit } from '@angular/core';
import { RedirectionLandingService } from '@src/app/core/services/ib-subscription-models-redirection-service';
import { subscriptionModelsAppConstant } from '@src/ib-subscription-models-app-constants';
import { CommonsSessionStorageService, downgradeToAJSComponent } from 'ib-web-commons/utils';
import { IbSubscriptionModelsPaymentsService } from './service/payments/ib-subscription-models-payments.service';
import { IbSubscriptionModelsPaymentWebComponentService } from './service/payments-web-component/ib-subscription-models-payments-web-component.service';
import { ReactComponentData } from '@src/app/core/models/generic-models';
import { initSubscriptionModelsServiceModel } from '@src/app/core/models/summary-service.model';
import { Summary, SummaryProps } from 'commercial-management--ancillaries--web-components-design--library';


@Component({
    selector: 'ib-subscription-models-payments',
    templateUrl: './ib-subscription-models-payments.component.html',
    styleUrls: ['./ib-subscription-models-payments.component.scss']
})
export class IbSubscriptionModelsPaymentsComponent implements OnInit {

    public contextId:string;
    private paymentComponent: any;

    public summaryComponent: ReactComponentData<SummaryProps> = {
        component: Summary,
        props: {} as SummaryProps
    };

    constructor (
        @Inject('CommonsModalService') private commonsModalService: CommonsModalService,
        @Inject('RedirectionLandingService') private redirectionLandingService: RedirectionLandingService,
        private commonsSessionStorageService: CommonsSessionStorageService,
        private ibSubscriptionModelsPaymentsService: IbSubscriptionModelsPaymentsService,
        private ibSubscriptionModelsPaymentWebComponentService: IbSubscriptionModelsPaymentWebComponentService

    ) {}

    async ngOnInit (): Promise<void> {
        this.showWaitingModal();
        this.commonsSessionStorageService.set('actualStepFlow', 'ibpurc');
        this.commonsSessionStorageService.set(subscriptionModelsAppConstant.SESSION_STORAGE.IS_NEW_PAYMENT, true);

        try {
            const response: initSubscriptionModelsServiceModel = await this.ibSubscriptionModelsPaymentsService.initPaymentForm();
            this.contextId = response.paymentContext;

            this.paymentComponent = await this.ibSubscriptionModelsPaymentWebComponentService.getNewPaymentComponent({
                contextId: this.contextId,
                onPaymentFailure: this.paymentFailure,
                onPaymentSuccess: this.paymentOk,
                target: document.querySelector('#pmt-container'),
                auth:{token:this.commonsSessionStorageService.get('anonymousToken')}
            });

            this.summaryComponent.props = response.summaryProps;
            this.closeWaitingModal();

        } catch (error) {
            this.closeWaitingModal();
            this.commonsModalService.showGenericError(error, true, null).result.then(() => {
                this.redirectionLandingService.redirection(subscriptionModelsAppConstant.market.toLowerCase(), subscriptionModelsAppConstant.lang.toUpperCase());
            });
        }
    }

    paymentOk (): void {
        window.location.hash = '#!' + subscriptionModelsAppConstant.PAGES_ROUTES.CONFIRMATION;
    }

    paymentFailure (): void {
        window.location.href = window.location.origin;
    }

    private showWaitingModal (): void {
        this.commonsModalService.showWaitingModal('ib-modal-loading-plane', 'ib-modals ib-modals--transparent ib-modals--loading-page', true, null);
    }

    private closeWaitingModal () {
        this.commonsModalService.finishWaiting();
        this.commonsModalService.closeAllCurrentModals();
    }

}

downgradeToAJSComponent('ibSubscriptionModelsPayments', {
    component: IbSubscriptionModelsPaymentsComponent,
    inputs: []
}, 'ib-subscription-models-payments');
